import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Api
import especie_api from '../../../../api/especie_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../../context/auth';

function initialStateEspecie() {

    return {
        identificacao: "",
        status: "Ativo",
        observacao: "",
        fotoModelo: ""
    }
}
export default function Especies({ permissoes }) {
    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    //Função de troca de estado de visbilidade do modal
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
        if (visibleModal) {
            loadEspecies();
            setEspecie(initialStateEspecie());
            setErrors({});
        }
    };

    //Pegando o estado de exibição do loading na tela
    const { setLoading } = useAuth();

    //Estado de controle da lista de especies
    const [especies, setEspecies] = useState([]);

    //Estado que guarda o id do tipo de compensacao para edição
    const [especie, setEspecie] = useState(initialStateEspecie);

    //Função que salva o id do tipo de compensacao para edição
    const editar = (especie) => {
        setLoading(true);
        especie_api.getItem(especie.id).then(response => {
            setEspecie(response.data);
            toggleModal();
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Ações que a tabela terá
    const actions = [
        editavel ?
            actionsTable.editar(editar)
            : actionsTable.visualizar(editar)
    ];


    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]
    //Função que carrega os tipos de compensação
    const loadEspecies = () => {
        setLoading(true);
        especie_api.getList().then(response => {
            setEspecies(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Variavel dos campos de cadastro obrigatorios
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "fotoModelo", required: true }),
    ]

    //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _especie = {
            ...especie,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_especie, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setEspecie(_especie);
    }

    //Função de onChange do arquivo de anexo
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            setEspecie({
                ...especie,
                fotoModelo: base64,
                caminhoArquivo: especie.id ? base64 : ""
            });
        });

        FR.readAsDataURL(e.target.files[0]);
    }

    //Função para dar submit nos dados da especie
    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(especie, campos);
        setErrors(_errors[0])

        if (_errors[1].length > 0)
            return;

        //Realizando o cadastro/edição da espécie
        setLoading(true);
        const _especie = { ...especie };
        delete _especie.caminhoArquivo;
        if (especie.id) {
            especie_api.put(_especie).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar a espécie!", "success", toggleModal);
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            });
        } else {
            especie_api.post(_especie).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar a espécie!", "success", toggleModal);
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            });
        }
    }

    //Função que carrega a lista de especies
    useEffect(() => {
        loadEspecies();
    }, []);

    return (
        <>
            <ModalCustomized btnClose={true} isOpen={visibleModal} toggle={toggleModal} title={especie.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar espécie</> : "+ Adicionar Espécie"}>
                <Row>
                    <Col md="12" lg="8">
                        <TextField
                            maxLength={150}
                            label="* Identificação"
                            name={"identificacao"}
                            onChange={onChange}
                            value={especie.identificacao}
                            invalid={!!errors.identificacao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Status"
                            name={"status"}
                            options={
                                [
                                    { label: "Ativo", value: "Ativo" },
                                    { value: "Inativo", label: "Inativo" }
                                ]
                            }
                            onChange={onChange}
                            value={especie.status}
                            invalid={!!errors.status}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            type={"textarea"}
                            label="Observação"
                            name={"observacao"}
                            onChange={onChange}
                            value={especie.observacao}
                            invalid={!!errors.observacao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            label="Foto do modelo"
                            name={"fotoModelo"}
                            type={"file"}
                            onChange={onChangeAnexo}
                            value={especie.fotoModelo}
                            invalid={!!errors.fotoModelo}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col className='d-flex align-items-center justify-content-center' md="12" lg="12">
                        <img className='rounded' src={`${especie.id ? especie.caminhoArquivo : especie.fotoModelo}`} alt="" width={200} />
                    </Col>
                    {
                        editavel &&
                        <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mt-4'>
                            <Button className='px-4' color={especie.id ? 'warning text-white' : 'success'} onClick={onSubmit}>{especie.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}</Button>
                        </Col>
                    }
                </Row>
            </ModalCustomized>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Espécies</h4>
                {editavel &&
                    <Button color='success' onClick={() => { toggleModal() }}>+ Cadastrar</Button>
                }
            </div >
            <TabelaListagem actions={actions} title={"Lista de espécies"} options={{ print: false, search: true, pagination: true }} headers={headers} items={especies} />
        </>
    )
}